import { render, staticRenderFns } from "./CreateAlertRuleModal.vue?vue&type=template&id=0ffe2f83&scoped=true&"
import script from "./CreateAlertRuleModal.vue?vue&type=script&lang=js&"
export * from "./CreateAlertRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlertRuleModal.vue?vue&type=style&index=0&id=0ffe2f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe2f83",
  null
  
)

export default component.exports